<template>
  <ItemSelectModal
    title="顧客選択"
    :items="allCustomers"
    :minItemSize="64"
    :loading="busy"
    infinite
    v-on="$listeners"
    @next="fetch"
  >
    <template #nodata>
      <CustomerIcon width="64" height="64" />
      該当する顧客が見つかりませんでした。
    </template>
    <template v-slot="{ item }">
      <div class="customer">
        <div class="names">
          <div class="name">{{ item.name }}</div>
          <span>様</span>
        </div>
        <VisitCount :visitCount="item.visitCount" />
        <dl v-if="item.tel || item.tel2 || item.company.name" class="attr">
          <template v-if="item.tel || item.tel2">
            <dt><TelIcon /></dt>
            <dd>
              {{ item.tel || item.tel2 }}<template v-if="item.tel && item.tel2"> / {{ item.tel2 }}</template>
            </dd>
          </template>
          <template v-if="item.company.name">
            <dt><CompanyIcon /></dt>
            <dd>{{ item.company.name }}</dd>
          </template>
        </dl>
      </div>
    </template>
  </ItemSelectModal>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ItemSelectModal from '@/components/molecules/ItemSelectModal'
import VisitCount from '@/components/molecules/VisitCount'
import CompanyIcon from '@/components/icons/company'
import CustomerIcon from '@/components/icons/customer'
import TelIcon from '@/components/icons/TelIcon'

export default {
  name: 'CustomerSelectModal',
  components: {
    ItemSelectModal,
    VisitCount,
    CompanyIcon,
    CustomerIcon,
    TelIcon,
  },
  props: {
    condition: Object,
  },
  computed: {
    ...mapState({
      busy: state => state.customers.busy,
    }),
    ...mapGetters({
      allCustomers: 'customers/all',
    }),
  },
  mounted() {
    this.$store.commit('customers/clear')
    this.fetch()
  },
  methods: {
    fetch() {
      this.$store.dispatch('customers/getCandidates', this.condition)
    },
  },
}
</script>

<style lang="postcss" scoped>
.customer {
  align-items: center;
  display: grid;
  font-size: 13px;
  grid-gap: 8px;
  grid-template-columns: 1fr auto;
  white-space: nowrap;
}

.names {
  align-items: baseline;
  display: grid;
  grid-auto-flow: column;
  grid-gap: 4px;
  justify-content: flex-start;
  overflow: hidden;
}

.name {
  font-size: 15px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
}

.attr {
  display: grid;
  grid-column: 1 / -1;
  grid-gap: 8px;
  grid-template-columns: auto 1fr;

  dt {
    fill: var(--very-dark-gray-2);
    line-height: 1;
  }

  dd {
    align-self: center;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  svg {
    height: 16px;
    width: 16px;
  }
}
</style>
